import React from 'react';
import { Field } from 'react-final-form';

interface Props {
    when: string;
    is?: any;
    children: React.ReactElement;
}

/**
 * Conditionally show or hide some parts of your form depending on values the user has already provided for other form inputs.
 * {@link https://codesandbox.io/s/lm4p3m92q}
 */
const Condition = ({
    when,
    is,
    children
}: Props): React.ReactElement | null => (
    <Field name={when} subscription={{ value: true }}>
        {({ input: { value } }) => {
            // Check to see if value matches provided condition
            if (is) {
                return value === is ? children : null;
            }
            // If no condition is provided check to see if value exists
            return value ? children : null;
        }}
    </Field>
);

export default Condition;
